<template>
  <div>
    <data-list class="select_checkbox_column_width_0" :payload="warehouseDataObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination">
      <template slot="filterForm">
        <v-layout row class="pa-3">
          <v-flex lg2 md3>
            <v-btn color="primary" class="ml-2" @click="openDialogHandler" dark>{{ $t('message.common.new') }}</v-btn>
          </v-flex>
          <v-flex lg1 md3>
            <v-btn color="info" class="ml-2" :loading="exportLoading" @click="exportLocations" dark>{{ $t('message.common.export') }}</v-btn>
          </v-flex>
          <v-flex lg1 md3>
            <v-btn color="success" class="ml-2" @click="importLocations(true)" dark>{{ $t('message.common.import') }}</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex lg3 md5 class="text-right">
            <v-text-field persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable @keyup.enter="getListHandler" @click:append="getListHandler" append-icon="search" outlined dense v-model="search" :label="$t('message.common.search')" class="search-hint-padding" id="searchbtn"></v-text-field>
          </v-flex>
        </v-layout>
      </template>
    </data-list>
    <v-dialog v-model="dialog" width="750" persistent>
      <form-template :references.sync="formReferences" :model="warehouseLocObj" ref="warehouseLocReference"></form-template>
    </v-dialog>
    <!-- Import Dialog -->
    <v-dialog persistent max-width="600px" v-model="importDialog">
      <v-card>
        <v-card-title>
          <h3>{{ $t('message.stock.importLocations') }}</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="importForm" v-if="importDialog">
            <v-row>
              <v-col cols="12" lg="12">
                <v-file-input :label="$t('message.product.chooseFile')" accept=".xlsx, .xls" outlined v-model="importLocationFile" hide-details></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-flex class="text-end">
            <v-btn color="info" @click="importFileHandler" :loading="importLoading">{{ $t('message.common.import') }}</v-btn>
            <v-btn color="error" @click="importLocations(false)">{{$t('message.common.close')}}</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import DataList from '../../components/DataList.vue'
import axios from 'axios'
import FormTemplate from '../../components/FormTemplate'
export default {
  data () {
    return {
      total: 0,
      dialog: false,
      warehouseLocObj: { isactive: true, isdefault: false },
      warehouseDataObj: {
        isHeader: true,
        isHideAdd: false,
        selection: [],
        showSelect: true,
        hasFilters: true,
        list: [],
        loading: false,
        page: 1,
        editProp: 'name',
        addClickHandler: this.openDialogHandler,
        editHandler: this.getSingleWarehouseHandler
      },
      loading: false,
      search: '',
      exportLoading: false,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.WAREHOUSE_LOCATION) ? this.$store.state.WAREHOUSE_LOCATION : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      importDialog: false,
      importLocationFile: [],
      importLoading: false
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  computed: {
    headers () {
      return [{
        text: this.$t('message.customer.name'),
        value: 'name',
        isRoute: true,
        isModal: true,
        width: '30%'
      }, {
        text: this.$t('message.layout.warehouse'),
        value: 'warehouse_name',
        sortable: true,
        width: '30%'
      }, {
        text: this.$t('message.common.isActive'),
        value: 'isactive',
        isBoolean: true,
        sortable: false,
        width: '20%'
      }, {
        text: this.$t('message.common.isDefault'),
        value: 'isdefault',
        isBoolean: true,
        sortable: false,
        width: '20%'
      }]
    },
    ...mapState(['FORM_TYPE', 'listOfWarehouse']),
    formReferences () {
      return {
        title: this.warehouseLocObj.id ? this.$t('message.warehouse.updateLocation') : this.$t('message.warehouse.addLocation'),
        properties: [{
          model: 'name',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.customer.name'),
          class: 'xs6'
        }, {
          model: 'warehouseid',
          rules: this.$_requiredValidation,
          type: this.FORM_TYPE.AUTO_COMPLETE,
          class: 'xs6',
          is_list: true,
          click: (term) => this.supportingList(this.WAREHOUSE, term),
          term: 'warehouse',
          items: this.listOfWarehouse,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.warehouse')
        }, {
          model: 'isactive',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs6 pt-2',
          label: this.$t('message.common.isActive')
        }, {
          model: 'isdefault',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs6 pt-2',
          label: this.$t('message.common.isDefault')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.warehouseLocObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        this.rememberPagination(val)
        this.getListHandler()
      },
      deep: true
    },
    search (val) {
      let pagination = this.$formatter.cloneVariable(this.pagination)
      pagination.search = val
      this.rememberPagination(pagination)
      if (!val) this.getListHandler()
    }
  },
  mounted () {
    this.search = this.pagination.search || ''
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.WAREHOUSELOCATION) {
        let payload = { ids: data.ids, url: `${this.WAREHOUSELOCATION}/delete_multiple`, module: 'warehouselocations' }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.WAREHOUSELOCATION) {
        this.warehouseDataObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
    this.$store.dispatch('getWarehouse')
      .then(() => {
        if (!this.warehouseLocObj.id) this.setDefaultValues({ prop: 'warehouseid', list: this.listOfWarehouse })
      })
    this.$eventBus.$on('setItemInField', (data) => {
      let model = Object.assign({ ...this.modelObj }, { [data.modelName]: data.recordId })
      this.modelObj = model
    })
  },
  methods: {
    rememberPagination (pagination) {
      let model = {
        type: 'WAREHOUSE_LOCATION',
        data: pagination
      }
      this.$store.commit('rememberOrder', model)
    },
    getListHandler () {
      this.warehouseDataObj.loading = true
      this.warehouseDataObj.module = this.WAREHOUSELOCATION
      let fields = this.$formatter.cloneVariable(this.headers)
      fields.splice(1, 1)
      let queryFields = fields
      let { page, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let pageVal = page || 1
      let sort = queryFields.find(x => x.value === sortBy[0])
      let query = {
        'expand': [{
          'select': ['name'],
          'model': 'Warehouse',
          'on_field': 'id',
          'on_parent_field': 'warehouseid',
          'filter': `name contains '${this.search}'`,
          'order_by': {
            'field': sortBy[0] === 'warehouse_name' ? 'name' : null,
            'asc_or_desc': sortBy[0] === 'warehouse_name' ? sortDesc[0] ? 'desc' : 'asc' : null
          } }
        ],
        'order_by': {
          'field': sort ? sort.value : null,
          'asc_or_desc': sortDesc[0] ? 'desc' : 'asc'
        },
        'skip': ((pageVal - 1) * itemsPerPage),
        'limit': itemsPerPage,
        'include_count': true,
        'filter': `${queryFields.map(x => x.value).join(` contains '${this.search || ''}' OR `)} contains '${this.search || ''}'`
      }
      this.$_executeApi('post', 'warehouselocations/query', query)
        .then((response) => {
          let { values, count } = response.data
          this.warehouseDataObj.loading = false
          this.warehouseDataObj.list = values
          this.total = count
          if (this.pagination.page > 1 && this.total <= this.pagination.itemsPerPage * (this.pagination.page - 1)) {
            this.pagination.page = 1
            this.warehouseDataObj.page = 1
          }
        })
    },
    supportingList (type, text) {
      const modelName = text
      text = this.$refs.warehouseLocReference.$refs[text][0].lazySearch
      let model = { module: type, dialog: true, text, modelName }
      this.$store.commit('supportingList', model)
    },
    getSingleWarehouseHandler (id) {
      this.$_getSingleRecordHandler(`warehouselocations/${id}`)
        .then((result) => {
          if (result.data) this.warehouseLocObj = result.data
          this.dialog = true
        })
    },
    openDialogHandler () {
      this.dialog = true
      this.warehouseLocObj.isactive = true
    },
    closeDialogHandler () {
      this.dialog = false
      this.warehouseLocObj.id = undefined
      this.$refs.warehouseLocReference.$refs.validateForm.reset()
    },
    saveUpdateHandler () {
      if (this.$refs.warehouseLocReference.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.warehouseLocObj
        let url = 'warehouselocations'
        if (!model.isdefault) model.isdefault = false
        this.$_saveUpdateHandler(url, model)
          .then(() => {
            this.closeDialogHandler()
            this.getListHandler()
            this.loading = false
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    exportLocations () {
      this.exportLoading = true
      this.$_executeApi('post', 'warehouselocations/export')
        .then(response => {
          const fileName = response.data
          window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
        }).finally(() => {
          this.exportLoading = false
        })
    },
    importLocations (action) {
      this.importDialog = action
      this.importLocationFile = []
      if (this.$refs.importForm) this.$refs.importForm.reset()
    },
    importFileHandler () {
      this.importLoading = true
      let file = this.importLocationFile
      var formData = new FormData()
      formData.append(file.name, file)
      this.$_executeApi('post', 'warehouselocations/import', formData).then(response => {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.importSuccess') })
        this.importLocations(false)
      }).finally(() => {
        this.importLoading = false
        this.getListHandler()
      })
    },
    setDefaultValues (data) {
      let { list, prop } = data
      if (list && list.length === 1) {
        let model = Object.assign({ ...this.warehouseLocObj }, { [prop]: list[0].id })
        this.warehouseLocObj = model
      }
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
    this.$eventBus.$off('setItemInField')
  }
}
</script>
